/**
 * Een paar "aggregator"-accounts in onze database fungeren als verzamel-user
 * voor activiteiten die niet aan een echte (op zichzelf staande) organisator
 * gekoppeld zijn:
 *
 *   - `pga-system-user` (Positief Gezond Almere) → eigenaar van alle
 *     activiteiten die via de PGA-API binnenkomen.
 *   - `6c39a88b-1c77-43ba-9c46-b5a5068628b8` (Hoi Buur Redactie) → eigenaar
 *     van campagne-seed activiteiten waarvoor de echte organisator (nog) geen
 *     eigen Hoi Buur-account heeft.
 *
 * Het profiel van zo'n aggregator-account toont een ratjetoe van activiteiten
 * van verschillende echte organisaties (5000 Stappen, Visit Almere, Senior-
 * Live, …) en is daarmee verwarrend voor bezoekers. Daarom maken we de
 * organisator-naam op een activiteits-kaart of detailpagina **niet** klikbaar
 * wanneer de achterliggende organizer een aggregator is.
 *
 * `organizer_name` / `organization_name` blijft uiteraard wel zichtbaar — alleen
 * de hyperlink wordt onderdrukt.
 */

const AGGREGATOR_ORGANIZER_IDS = new Set([
  'pga-system-user',
  '6c39a88b-1c77-43ba-9c46-b5a5068628b8',
]);

export const isAggregatorOrganizer = (activity) => {
  if (!activity) return false;
  if (activity.source === 'pga') return true;
  return AGGREGATOR_ORGANIZER_IDS.has(activity.organizer_id);
};
